import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getModelProvider } from './modelProvider.constants';

type ModelProviderAttributionProps = {
  source: string;
  geoEventId: number;
};

export const ModelProviderAttribution = (
  props: ModelProviderAttributionProps,
): JSX.Element | null => {
  const { source, geoEventId } = props;
  const { t } = useTranslation();

  const provider = getModelProvider(source);

  if (!provider) {
    return null;
  }

  return (
    <Stack sx={{ px: 2, py: 2 }} gap={2}>
      <Typography variant="h3" sx={{ fontWeight: 'fontWeightMedium' }}>
        {t('wildfireProgressionModel.modelProvider')}
      </Typography>

      <Divider />

      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
        <Box
          component="img"
          src={provider.logoWordmark}
          alt={provider.displayName}
          sx={{ maxHeight: 60, maxWidth: '70%', objectFit: 'contain' }}
        />
      </Box>

      <Typography variant="body1">
        {t(
          `wildfireProgressionModel.providers.${provider.source}.cardDescription`,
        )}
      </Typography>

      <Button
        component={Link}
        to={`/i/${geoEventId}/models/provider/${provider.source}`}
        fullWidth
        sx={{
          backgroundColor: 'grey.300',
          color: 'rgba(0,0,0,0.87)',
          borderRadius: '12px',
          height: 48,
          fontWeight: 'fontWeightMedium',
          fontSize: '1rem',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: 'grey.400',
          },
        }}
      >
        {t('wildfireProgressionModel.viewProfile')}
      </Button>
    </Stack>
  );
};
